import React from 'react';

import './Loading.css';

const Loading = () => {
  return <h3 className="Loading-text">Loading...</h3>;
};

export default Loading;
